/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const configQueryOptions = (queryParams) =>
  queryOptions({
    queryKey: queryKeys.config.all,
    queryFn: () => fetcher({ method: "GET", url: "/public/config" }),
    staleTime: Infinity,
    ...queryParams,
  });

export const useConfig = (queryParams) => useQuery(configQueryOptions(queryParams));
export const useSuspenseConfig = (queryParams) => useSuspenseQuery(configQueryOptions(queryParams));
